// extracted by mini-css-extract-plugin
module.exports = {"container":"linkBoxes-module--container--1FmzQ","box":"linkBoxes-module--box--rvZoL","boxes":"linkBoxes-module--boxes--32cz5"};